module.exports = __webpack_public_path__ + "static/media/19taichinh.8b74808f.jpg";